export default "__VITE_ASSET__ClNr8aFM__"